export const initialState = {
  competenceOrder: {
    competenceOrderId: null,
    approvalTypeName: '',
    statusName: '',
    expression: '',
    stopAfterFirstTrueRuleYN: true,
    changed: false
  }
};

export function reducer(state, action) {
  switch (action.type) {
    case 'OnInitState':
      return onInitState(state, action);
    case 'OnHeaderPropertyChanged':
      return onHeaderPropertyChanged(state, action);
    case 'OnHeaderSaved':
      return onHeaderSaved(state, action);
    default:
      return state;
  }
}

function onHeaderSaved(state) {
  return {
    ...state,
    competenceOrder: {
      ...state.competenceOrder,
      changed: false
    }
  };
}

function onInitState(state, action) {
  // eslint-disable-next-line no-unused-vars
  const { competenceOrderRules, ...cOrder } = action.data;
  return {
    ...state,
    competenceOrder: { ...cOrder, changed: false }
  };
}

function onHeaderPropertyChanged(state, action) {
  const { propertyName, value } = action;
  return {
    ...state,
    competenceOrder: {
      ...state.competenceOrder,
      [propertyName]: value,
      changed: true
    }
  };
}
